import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_3xl, font_family_weight_medium } from 'ext-ui/style/typography'
import { css } from 'styled-components'

const margin = spacing(5)
const paddingHorizontal = spacing(10)

export default css`
  &.FiltersFlyout .BaseFlyout-Container {
    box-shadow: none;
  }

  &.FiltersFlyout .BaseFlyout-Content {
    margin: ${margin};
    border-radius: ${spacing(2)};

    display: flex;
    flex-direction: column;

    width: ${spacing(100)};
    height: calc(100% - 2 * ${margin});

    .BaseFlyout-CloseBar {
      padding: ${spacing(5)} ${paddingHorizontal} 0;
    }

    .BaseFlyout-Header {
      padding: ${spacing(5)} ${paddingHorizontal};
      h2 {
        margin: 0;
        font-family: ${font_family_weight_medium};
        ${font_3xl}
        color: ${text_colorTextPrimary};
      }
    }

    .BaseFlyout-Body {
      background-color: ${base_colorRaisedSurface};
      padding: 0;

      flex: auto;
      min-height: 0;

      display: flex;
      flex-direction: column;

      .FiltersFlyout-Filters {
        padding: ${spacing(5)} ${paddingHorizontal};
        flex: auto;
        min-height: 0;
        overflow: auto;
      }

      .FiltersFlyout-BottomBar {
        display: flex;
        justify-content: space-between;
        align-items: center;

        background-color: ${base_colorSurfaceSecondary};
        padding: ${spacing(6)} ${paddingHorizontal};
        border-top: 1px solid ${base_colorContentBorder};
      }
    }
  }
`
